import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { DashboardDeviceStatus } from 'src/app/models/dashboard-models/dasboard-device-status.model';
@Component({
  selector: 'app-dashboard-devices-devices-card',
  templateUrl: './dashboard-devices-devices-card.component.html',
  styleUrls: ['./dashboard-devices-devices-card.component.scss']
})
export class DashboardDevicesDevicesCardComponent implements OnInit, AfterContentChecked {

  @Input() data: Array<DashboardDeviceStatus>;
  countOnline: any;
  countOffline: any;
  countDisabled: any;
  countOfflineToday: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.showCounter = false;
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('devices-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data)) {
      this.spinnerService.hide('devices-counts-spinner');
      this.showCounter = true;
      const onlineDevices = this.data.filter(d => d.Label === 'ONLINE')[0];
      this.countOnline = onlineDevices ? onlineDevices.count : 0;
      const offlineDevices = this.data.filter(d => d.Label === 'OFFLINE')[0];
      this.countOffline = offlineDevices ? offlineDevices.count : 0;
      const disabledDevices = this.data.filter(d => d.Label === 'DISABLED')[0];
      this.countDisabled = disabledDevices ? disabledDevices.count : 0;
      const offlineTodaydDevices = this.data.filter(d => d.Label === 'OFFLINE_TODAY')[0];
      this.countOfflineToday = offlineTodaydDevices ? offlineTodaydDevices.count : 0;
    } else {
      this.countOnline = 0;
      this.countOffline = 0;
      this.countDisabled = 0;
      this.countOfflineToday = 0;
      this.showCounter = true;
      this.spinnerService.hide('devices-counts-spinner');
    }
  }

}
